export default __webpack_public_path__ + "6a4854685a90b0748212e4bc8a23d6c8.png";